export default __webpack_public_path__ + "static/icon-25-5-b09a58a02d7598f1d3728954c62d8831.png";